import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

const ImageZoom = ({ imageUrl, alt = 'tr' }) => {
  const [zoomed, setZoomed] = useState(false);

  const open = () => setZoomed(true);
  const close = useCallback(() => setZoomed(false), []);

  // Lock scroll + ESC to close while zoomed
  useEffect(() => {
    if (!zoomed) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [zoomed, close]);

  return (
    <div className="gallery-box">
      <div className="img-thumb" onClick={open}>
        <img className="img-fluid" src={imageUrl} alt={alt} />
      </div>

      <div className="overlay-box text-center" onClick={open}>
        <i className="lni-plus"></i>
      </div>

      {zoomed && createPortal(
        <div
          className="zoomed-image"
          role="dialog"
          aria-modal="true"
          onClick={close} // click backdrop to close
        >
          <button className="zoom-close" aria-label="Close" onClick={close}>×</button>
          {/* stop propagation so clicking the image doesn't close */}
          <img className="img-fluid" src={imageUrl} alt={alt} onClick={(e) => e.stopPropagation()} />
        </div>,
        document.body
      )}
    </div>
  );
};

export default ImageZoom;
